// extracted by mini-css-extract-plugin
module.exports = {"root":"relatedLinks_root__Durmx","youtube":"relatedLinks_youtube__VKScO","facebook":"relatedLinks_facebook__3LxO4","line":"relatedLinks_line__2OQCw"};